module.exports = __webpack_public_path__ + "img/tointos04.2ca72e71.jpg";